import { CheckLQ, FutureNotification, DOFlow, MTNValidation, HOAFlow } from './../constants/actionType'

const initialState = {
    validVzw:"N",
    chatupdateurl : {},
    chatupdateurlcount : 0,
    selectedState: null,
    selectedAdr: null,
    selectedUnit: null,
    isStreetFetchDone: false,
    showCity: false,
    showExistingService: false,
    showUnit: false,
    showLQBtn: false,
    mtnEmailVisible: false,
    cartFirstAddition:false,
    apiCount: 1,
    signInErrorMH: false,
    signinMHSuccess: false,
    skipfornowMH: false,
    showSignIn: true,
    zipCodes: [],
    streetAddrs: [],
    units: [],
    lqResponse: {},
    streamlineLQ: false,
    streamlinePopularPlan:false,
    checkfor5gresponse: {},
    is5GRecommended: false,
    servicesQualified: {
        isDataQualified: true,
        isHsiQualified: true,
        isVideoQualified: true,
        isVoiceQualified: true
    },
    lqQualdetails: {},
    showZipLoader: false,
    isRememberMeChecked: true,
    redirectingFYH: 'N',
    lboRedirectOOF: 'N',
    newService: true,
    lqRevisit: "N",
    isoneLQFlow: true,
    isBuffalloDMA:false,
    isamazonMovers: false,
    triggerLQ: false,
    isCaptchaAPI: false,
    isoneLQFlowDev: false,
    isQAMLessFlow:false,
    isMultiadr: false,
    skipCaptcha: false,
    showLQBtnAdrEntry: false,
    adrEntered: '',
    unitEntered: '',
    signInAs: "AF",
    zipNotFound: false,
    suggestedAddress: [],
    captchaState: '', //''
    showCaptchaFromVisitId: false, //false
    showLBOFromVisitId: false,
    futureNotification: {
        fNameErr: false,
        lNameErr: false,
        emailErr: false,
        mtnErr: false,
        ftvCheckErr: false,
        ftvCheck: false,
        firstName: "",
        lastName: "",
        eMailID: "",
        mtn: "",
        phoneNo: {
            ph1: '',
            ph2: '',
            ph3: ''
        },
        validationsucess: false,
        validationfailure: false,
    },
    cantFindAddress: false,
    disableUnitTypeahead: false,
    existingSerive: "",
    move: {
        isPendingOrderAvailable: false
    },
    doFlowDetails: {
        isDoFlow: false,
        DOIDValue: null,
        DOStatus: false,
        DOError: false
    },
    hoaFlowDetails :{
        isHoaFlow : false,
    },
    token: "",
    couponFlowType: null,
    couponFlowStatus: null,
    signInCoupon: {
        mtn: "",
        phoneNo: {
            ph1: '',
            ph2: '',
            ph3: ''
        },
        mtnErr: false,
        phoneNumCheck: false,
    },
    vendorDetails: null,
    vendorSalesDetails:null,
    vendorName: '',
    primaryAccountIndicator: "N",
    isCCEligible: "N",
    isVZWOfferCallComplete: false,
    chatEnable: false,
    isFCPflow: false,
    isOtpBypassFlow: false,
    preSaleEligible: false,
    preSaleEstimateDays: "",
    iONTEligible: false,
    vzwOfferEligibilityCallPage: "",
    isCouponLQPage: false,
    couponFlowPageLoad:false,
    connFlowNCClick:false,
    bannerType: '',
    lstBanners: '',
    lstFlashOfferDetails: '',
    lstRibbonContent:'',
    vCustId: '',
    vAcctId: '',
    vzwOffer: '',
    checkPDCResFCC: {},
    vzwMtn: undefined,
    isVzwAccountEligibile:'N',
    npmLofFlow: false,
    custFromAddrId: '',
    isFcpInProfile: false,
    addressIDSelected: "",
    runtimeKey: null,
    is5GRecommended: false,
    is4GRecommended: false,
    showStreetLoader: false,
    isNYDMA: false,
    agencyId: '',
    isClassicUTD: false,
    showStadia: false,
    showMarvel:false,
    mfrtType:false,
    TWSlq2:false,
    mfrtHeaderhide:false,
    isVendorVisit: false,
    showNewYoutubeChanges: false,
    mlpFFCouponInfo: {
        ffCoupon: '',
        leadListID: '',
        isMLPPromoRefreshRequired: true
    },
    emergencyNotification: {
        states: null
    },
    fiveGEligibleZip: false,
    MFRTEligible: false,
    MFRTVerified: false,
    mfrtInitialLoad: true,
    MFRTCompleted: false,
    MFRTMovesFlow: false,
    MFRTDiscountEligible: false,
    MFRTProfileDiscountEligible: false,
    sweetnerMsgMFRT: {
        currentMsg: '',
        isDisplay: false,
        bgColor: '',
        discountEligible: false
    },
    dtmTransactionsMFRT: {
        TwsTransactionID: '',
        UNID: '',
        Status: '',
        Vendor: '',
        TWSsegment: '',
        Startdatetimestamp: '',
        Enddatetimestamp: ''
    },
    accessCode: false,
    startdatetimestamp: '',
    mnh: {
        mnhFlow: false,
        getCheckoutDataCalled: false,
        checkoutData: null,
        isGigqualified: false,
        creditStatus: "",
        pdcData: "",
        isChangeAdr: false,
        isMNHQS: false,
        isOneClickFlow: false,
        reserveSIDueDate: true,
        showCartOnCheckout: false,
        isCreditCompleted: false
    },
    quickCheckout: false,
    isOnVzwUnlimitedPlan: "",
    ecLQResponse: {},
    walmartflow: false,
    newoffertile: false,
    moversInvoked:false,
    isPushNotificationEnable : false,
    loopQualInputClear:false,
    isResidentialAddress: false,
    moversIntent:false,
    vcgOOFShowVBGMsg: false,
    inputAddress: null,
    displayStudentReverifySuccessMsg: '',
    vZWvZTCustIndicator: null,
    isVZWWireless: null,
    employeeOfferExists : null,
    isRuralBroadBandAddress : false,
    showAddrSection : true,
}

function loopQual(state = initialState, action) {
    switch (action.type) {
        case 'ZIP_NOT_FOUND':
            return Object.assign({}, state, {
                selectedState: null,
                streetAddrs: [],
                showCity: false,
                showSignIn: false,
                showZipLoader: false,
                showStreetLoader: false,
                zipNotFound: true,
                zipCodes: [],
                showUnit: false,
                showLQBtn: false,
                showLQBtnAdrEntry: false,
                selectedAdr: null,
                streetNotFound: true,
            })
        case 'CLEARLOOPQUALINPUT':
            return Object.assign({}, state, {
                loopQualInputClear: action.value
            })
        case 'STREET_NOT_FOUND':
            return Object.assign({}, state, {
                showCity: false,
                showSignIn: false,
                showZipLoader: false,
                showStreetLoader: false,
                streetNotFound: true,
                zipCodes: [],
                showLQBtn: false,
                showLQBtnAdrEntry: false,
                selectedAdr: null,
                zipNotFound: false,
                showUnit: false,
            })
        case 'UNIT_NOT_FOUND':
            return Object.assign({}, state, {
                showUnit: false
            })
        case 'SET_SHOW_MTN_EMAIL':
            return Object.assign({}, state, {
                mtnEmailVisible: action.value
            })
        case CheckLQ.cartFirstAddition:
                return Object.assign({}, state, {
                    cartFirstAddition: action.value
                })
        case CheckLQ.onZipcodeSelected:
            const showSignIn = !action.value;
            // let showSignIn = false
            // if(action.value === undefined || action.value === null || action.value === "")
            //     showSignIn = true;
            return Object.assign({}, state, {
                selectedState: action.value,
                streetAddrs: [],
                showCity: !!action.value,
                showSignIn,
                showZipLoader: false,
                // showStreetLoader : false,
                zipCodes: []

            })
        case CheckLQ.onStreetAddrSelected:
            return Object.assign({}, state, {
                selectedAdr: action.value.streetAddr,
                showLQBtn: action.value.isdisplayUnit ? false : (action.value.streetAddr !== null ? true : false),
                showSignIn: false,
                streetNotFound: false,
                zipNotFound: false,
            })
        case CheckLQ.setSelectedState:
            let selstate1 = Object.assign({}, action.value.streetAddr, {
                zip: action.value.streetAddr.zip,
                city: action.value.streetAddr.city,
                altCity: action.value.streetAddr.city,
                state: action.value.streetAddr.state,
            })
            return Object.assign({}, state, {
                selectedState: selstate1,
            })
        case CheckLQ.newService:
            return Object.assign({}, state, {
                newService: !action.value
            })
        case CheckLQ.lqRevisit:
            return Object.assign({}, state, {
                lqRevisit: action.value
            })
        case CheckLQ.lboRedirectOOF:
            return Object.assign({}, state, {
                lboRedirectOOF: action.value
            })
        case CheckLQ.signInAs:
            return Object.assign({}, state, {
                signInAs: action.value
            })
        case CheckLQ.chatEnable:
            return Object.assign({}, state, {
                chatEnable: action.value
            })
        case 'EXISTING_SERVICE':
            return Object.assign({}, state, {
                existingSerive: action.value
            })
        case 'MFRTN_SERVICE':
            return Object.assign({}, state, {
                MFRTNService: action.value
            })
        case 'SET_ZIP_CODES':
            return Object.assign({}, state, {
                zipCodes: action.value
            })
        case 'LQ_ON_ZIPCODE_CHANGE':
            return Object.assign({}, state, {
                zipCodes: action.value,
                showCity: false,
                showUnit: false,
                showLQBtn: false,
                showLQBtnAdrEntry: false,
                zipNotFound: false,
                streetNotFound: false,
            })
        case CheckLQ.onShowZipLoader:
            return Object.assign({}, state, {
                showZipLoader: action.value,
            })
        case CheckLQ.onShowStreetLoader:
            return Object.assign({}, state, {
                showStreetLoader: action.value,
            })
        case 'LQ_ON_STREETADDR_CHANGE':
            return Object.assign({}, state, {
                streetAddrs: action.value,
                showUnit: false,
                showLQBtn: false,
                streetNotFound: false,
            })

        case 'LQ_CANT_FIND_ADDRESS_CLICKED':
            return Object.assign({}, state, {
                cantFindAddress: action.value
            })

        case 'LQ_ON_UNIT_CHECK':
            return Object.assign({}, state, {
                units: action.value,
                showUnit: true,
                showLQBtn: false,
                showLQBtnAdrEntry: false
            })
        case 'LQ_ON_UNIT_CHANGE':
            /* let showlqbtn = false
            if(action.value !== undefined && action.value !== null && action.value.length > 0)
                showlqbtn = true;  */
            return Object.assign({}, state, {
                units: action.value,
                /* showLQBtn:showlqbtn,
                showLQBtnAdrEntry: showlqbtn, */
            })
        case 'LQ_DISABLE_UNIT_TYPEAHEAD':
            return Object.assign({}, state, {
                disableUnitTypeahead: action.value
            })
        case CheckLQ.validateSignin:
            let move = Object.assign({}, state.move, {
                move: action.value
            })
            return Object.assign({}, state, {
                move: move
            })
        case 'accountAndCustomerId':
            return Object.assign({}, state, {
                vCustId: action.value.visionCustomerId,
                vAcctId: action.value.visionAccountId,
                custFromAddrId: action.value.addressId,
                isFcpInProfile: action.value.isFcpInProfile,
                isClassicUTD: action.value.isClassicUTD,
                vZWvZTCustIndicator: action.value.vZWvZTCustIndicator,
                isVZWWireless: action.value.isVZWWireless,
                employeeOfferExists : action.value.employeeOfferExists
            })
        case CheckLQ.onUnitSelected:
            const { value } = action;
            return Object.assign({}, state, {
                selectedUnit: value,
                showLQBtn: value !== null ? true : false,
                showUnit: value && (value.unit !== null) ? true : false,
                showLQBtnAdrEntry: value !== null ? true : false
            })
        case CheckLQ.update5GRecommended: {
            const { is5GRecommended } = action;
            return (Object.assign({}, state, {
                is5GRecommended
            }))
        }
        case CheckLQ.update4GRecommended: {
            const { is4GRecommended } = action;
            return (Object.assign({}, state, {
                is4GRecommended
            }))
        }
        case 'CHECKFOR5G_RES':
            return Object.assign({}, state, {
                checkfor5gresponse: action.value
            })
        case 'IS_RURAL_BROADBAND_ADDRESS':
            return Object.assign({}, state, {
                isRuralBroadBandAddress: action.value
            }) 
        case 'SET_SHOW_ADDRESS_SECTION':
        return Object.assign({}, state, {
            showAddrSection: action.value
        })   
        case 'LQ_ON_CHECK_AVAILABILITY_CLICK':
            return Object.assign({}, state, {
                lqResponse: action.value,
                isFCPflow: action.value.isFCP ? true : false
            })
        case 'LQ_ON_RETRIEVE_QUALDETAILS':
            return Object.assign({}, state, {
                lqQualdetails: action.value
            })
        case 'LQ_ON_REMEMBERME_CHECK':
            return Object.assign({}, state, {
                isRememberMeChecked: !action.value
            })
        case 'SET_STREAMLINE_LQ':
                return Object.assign({}, state, {
                    streamlineLQ: action.value
                })
        case 'STREAMLINE_POPULARPLAN':
                return Object.assign({}, state, {
                    streamlinePopularPlan: action.value
                })

        case 'LQ_SET_QUALIFIED_SERVICES':
            let servicesQualified = Object.assign({}, state.servicesQualified, {
                isDataQualified: action.value !== null && action.value.isDataQualified !== undefined && action.value.isDataQualified !== null ? action.value.isDataQualified : true,
                isVideoQualified: action.value !== null && action.value.isVideoQualified !== undefined && action.value.isVideoQualified !== null ? action.value.isVideoQualified : true,
                isVoiceQualified: action.value !== null && action.value.isVoiceQualified !== undefined && action.value.isVoiceQualified !== null ? action.value.isVoiceQualified : true,
                isHsiQualified: action.value !== null && action.value.isHsiQualified !== undefined && action.value.isHsiQualified !== null ? action.value.isHsiQualified : true
            })
            return Object.assign({}, state, {
                servicesQualified: servicesQualified
            })
        case 'REDIRECTINGFYH':
            return Object.assign({}, state, {
                redirectingFYH: action.value
            })
        case FutureNotification.ftvCheck:
            let ftvChecked = Object.assign({}, state.futureNotification, {
                ftvCheck: !action.value
            })
            return Object.assign({}, state, {
                futureNotification: ftvChecked
            })
        case FutureNotification.fNameErr:
            let fNameError = Object.assign({}, state.futureNotification, {
                fNameErr: action.value
            })
            return Object.assign({}, state, {
                futureNotification: fNameError
            })
        case FutureNotification.lNameErr:
            let lNameError = Object.assign({}, state.futureNotification, {
                lNameErr: action.value
            })
            return Object.assign({}, state, {
                futureNotification: lNameError
            })
        case FutureNotification.emailErr:
            let emailError = Object.assign({}, state.futureNotification, {
                emailErr: action.value
            })
            return Object.assign({}, state, {
                futureNotification: emailError
            })
        case FutureNotification.mtnErr:
            let mtnError = Object.assign({}, state.futureNotification, {
                mtnErr: action.value
            })
            return Object.assign({}, state, {
                futureNotification: mtnError
            })
        case FutureNotification.mtn:
            let mtnValue = Object.assign({}, state.futureNotification, {
                mtn: action.value
            })
            return Object.assign({}, state, {
                futureNotification: mtnValue
            })
        case FutureNotification.ftvCheckErr:
            let ftvCheckError = Object.assign({}, state.futureNotification, {
                ftvCheckErr: action.value
            })
            return Object.assign({}, state, {
                futureNotification: ftvCheckError
            })
        case FutureNotification.validationsucess:
            let validationsucess = Object.assign({}, state.futureNotification, {
                validationsucess: action.value
            })
            return Object.assign({}, state, {
                futureNotification: validationsucess
            })
        case FutureNotification.validationfailure:
            let validationfailure = Object.assign({}, state.futureNotification, {
                validationfailure: action.value
            })
            return Object.assign({}, state, {
                futureNotification: validationfailure
            })
        case FutureNotification.intialstatusbackendcall:
            let validation = Object.assign({}, state.futureNotification, {
                validationfailure: action.value,
                validationsucess: action.value,
            })
            return Object.assign({}, state, {
                futureNotification: validation
            })
        case FutureNotification.validateInput:
            let futureNotificationInput = Object.assign({}, state.futureNotification, {
                firstName: action.value.firstName !== undefined &&
                    action.value.firstName !== state.futureNotification.firstName ? action.value.firstName : state.futureNotification.firstName,
                lastName: action.value.lastName !== undefined &&
                    action.value.lastName !== state.futureNotification.lastName ? action.value.lastName : state.futureNotification.lastName,
                eMailID: action.value.eMailID !== undefined &&
                    action.value.eMailID !== state.futureNotification.eMailID ? action.value.eMailID : state.futureNotification.eMailID,
                phoneNo: {
                    ph1: action.value.ph1 !== undefined &&
                        action.value.ph1 !== state.futureNotification.phoneNo.ph1 ? action.value.ph1 : state.futureNotification.phoneNo.ph1,
                    ph2: action.value.ph2 !== undefined &&
                        action.value.ph2 !== state.futureNotification.phoneNo.ph2 ? action.value.ph2 : state.futureNotification.phoneNo.ph2,
                    ph3: action.value.ph3 !== undefined &&
                        action.value.ph3 !== state.futureNotification.phoneNo.ph3 ? action.value.ph3 : state.futureNotification.phoneNo.ph3,
                }
            })
            return Object.assign({}, state, {
                futureNotification: futureNotificationInput,
            })
        case DOFlow.onDoFlowCreation:
            let doFlowDetails = Object.assign({}, state.doFlowDetails, {
                isDoFlow: true,
                DOIDValue: action.value,
                DOStatus: false,
                DOError: false
            })
            return Object.assign({}, state, {
                doFlowDetails: doFlowDetails
            })
        case HOAFlow.onHoaFlowCreation:
            let hoaFlowDetails = Object.assign({}, state.hoaFlowDetails, {
                isHoaFlow : action.value
            })
                return Object.assign({}, state, {
                    hoaFlowDetails: hoaFlowDetails
            })
        case DOFlow.onEmptyDoFlowStatus:
            let doFlowEmptyState = Object.assign({}, state.doFlowDetails, {
                isDoFlow: false,
                DOIDValue: "",
                DOStatus: false,
                DOError: false
            })
            return Object.assign({}, state, {
                doFlowDetails: doFlowEmptyState
            })
        case DOFlow.onDOStatus:
            let doStatus = Object.assign({}, state.doFlowDetails, {
                isDoFlow: true,
                DOIDValue: state.doFlowDetails.DOIDValue,
                DOStatus: action.value,
                DOError: state.doFlowDetails.DOError
            })
            return Object.assign({}, state, {
                doFlowDetails: doStatus
            })
        case DOFlow.onDOError:
            let doErrorStatus = Object.assign({}, state.doFlowDetails, {
                isDoFlow: true,
                DOIDValue: state.doFlowDetails.DOIDValue,
                DOStatus: state.doFlowDetails.DOStatus,
                DOError: action.value
            })
            return Object.assign({}, state, {
                doFlowDetails: doErrorStatus
            })
        case CheckLQ.updateToken:
            return Object.assign({}, state, {
                token: action.value
            })
        case CheckLQ.updateCouponFlowType:
            return Object.assign({}, state, {
                couponFlowType: action.value
            })
        case CheckLQ.updatecouponFlowStatus:
            return Object.assign({}, state, {
                couponFlowStatus: action.value
            })
        case CheckLQ.updateCouponLQPage:
            return Object.assign({}, state, {
                isCouponLQPage: action.value
            })
        case 'CONNFLOW_NCCLICK':
            return Object.assign({}, state, {
                connFlowNCClick: action.value
            })
        case 'CONNFLOW_PAGELOAD':
            return Object.assign({}, state, {
                couponFlowPageLoad: action.value
            })
        case 'CHATUPDATEURL':
            return Object.assign({},state,{
                chatupdateurl : action.value
            })
        case 'INCREASE_CHATURL_COUNT':
            return Object.assign({},state,
               { chatupdateurlcount :   1})
        case CheckLQ.validateSignInCoupon:
            let phoneNoInput = Object.assign({}, state.signInCoupon, {
                phoneNo: {
                    ph1: action.value.ph1 !== undefined &&
                        action.value.ph1 !== state.signInCoupon.phoneNo.ph1 ? action.value.ph1 : state.signInCoupon.phoneNo.ph1,
                    ph2: action.value.ph2 !== undefined &&
                        action.value.ph2 !== state.signInCoupon.phoneNo.ph2 ? action.value.ph2 : state.signInCoupon.phoneNo.ph2,
                    ph3: action.value.ph3 !== undefined &&
                        action.value.ph3 !== state.signInCoupon.phoneNo.ph3 ? action.value.ph3 : state.signInCoupon.phoneNo.ph3,
                }
            })
            return Object.assign({}, state, {
                signInCoupon: phoneNoInput,
            })
        case CheckLQ.mtnSignIn:
            let mtnVal = Object.assign({}, state.signInCoupon, {
                mtn: action.value
            })
            return Object.assign({}, state, {
                signInCoupon: mtnVal
            })
        case CheckLQ.mtnSignInErr:
            let mtnSignInError = Object.assign({}, state.signInCoupon, {
                mtnErr: action.value
            })
            return Object.assign({}, state, {
                signInCoupon: mtnSignInError
            })
        case CheckLQ.phoneNumCheck:
            let phoneNumberCheck = Object.assign({}, state.signInCoupon, {
                phoneNumCheck: !action.value
            })
            return Object.assign({}, state, {
                signInCoupon: phoneNumberCheck
            })
        case 'GET_VENDOR_DETAILS':
            return Object.assign({}, state, {
                vendorDetails: action.value
            })
        // Vendor flow : Visitid and visitor id QS issue fix without doid check - Need to test 
        // case 'VENDOR_SALESDETAILS':
        //         return Object.assign({}, state, {
        //             vendorSalesDetails: action.value
        //     })
        case CheckLQ.updateBannerType:
            return Object.assign({}, state, {
                bannerType: action.value
            })
        case "GET_BANNERS":
            return Object.assign({}, state, {
                lstBanners: action.value
            })
        case "GET_FLASH_OFFERDETAILS":
            return Object.assign({}, state, {
                lstFlashOfferDetails: action.value
            })
        case "GET_RIBBON_CONTENT":
                return Object.assign({}, state, {
                    lstRibbonContent: action.value
            })    
        case 'UPDATE_RETURNVISIT_SELECTEDSTATE':
            let selstate = Object.assign({}, state.selectedState, {
                zip: action.value.zip,
                city: action.value.city,
                altCity: action.value.city,
                state: action.value.state,
                tarCode: action.value.tarCode
            })
            return (Object.assign({}, state, {
                selectedState: selstate,
                showCity: true,
                showSignIn: false,
                showLQBtn: true,
                showLQBtnAdrEntry: true
            }))
        case 'UPDATE_RETURNVISIT_SELECTEDADDRESS':
            let adrstate = Object.assign({}, state.selectedAdr, {
                addressID: action.value.addressID,
                street: action.value.street,
                city: action.value.city,
                state: action.value.state,
                zip: action.value.zip,
            })
            return (Object.assign({}, state, {
                selectedAdr: adrstate
            }))

        case 'UPDATE_RETURNVISIT_SELECTEDUNIT':
            let unitstate = Object.assign({}, state.selectedUnit, {
                addressID: action.value.addressID,
                unit: action.value.unit,
            })
            return (Object.assign({}, state, {
                selectedUnit: unitstate,
                showUnit: true
            }))

            case 'validVzw':
                return Object.assign({},state,{
                    validVzw : "Y"
                })

        case MTNValidation.updateVZWOfferEligibility:
            return (Object.assign({}, state, {
                primaryAccountIndicator: (action.value.data === undefined || (action.value.data !== undefined && action.value.data.primaryAccountIndicator === undefined)) ? "N" : action.value.data.primaryAccountIndicator,
                isVZWOfferCallComplete: action.value.isVZWOfferCallComplete,
                isCCEligible: (action.value.data === undefined || (action.value.data !== undefined && action.value.data.isCCEligible === undefined)) ? "N" : action.value.data.isCCEligible,
                isOnVzwUnlimitedPlan: (action.value.data === undefined || (action.value.data !== undefined && action.value.data.isOnVzwUnlimitedPlan === undefined)) ? "N" : action.value.data.isOnVzwUnlimitedPlan,
            }))
        case MTNValidation.updateVZWOfferEligibilityStatus:
            return (Object.assign({}, state, {
                isVZWOfferCallComplete: action.value
            }))
        case CheckLQ.isFCPflow:
            return (Object.assign({}, state, {
                isFCPflow: action.value
            }))
        case "OTP_BYPASSFLOW":
            return (Object.assign({}, state, {
                isOtpBypassFlow: action.value
            }))
        case "EMPTYLQSSTATE":
            return initialState
        case "PRESALE_ELIGIBLE":
            return (Object.assign({}, state, {
                preSaleEligible: action.value
            }))
        case "PRESALE_ESTIMATEDAYS":
            return (Object.assign({}, state, {
                preSaleEstimateDays: action.value
            }))
        case "IONT_ELIGIBLE":
            return (Object.assign({}, state, {
                iONTEligible: action.value
            }))
        case "NYDMA_ELIGIBLE":
            return (Object.assign({}, state, {
                isNYDMA: action.value
            }))
        case MTNValidation.updateVZWOfferPageCallStatus:
            return (Object.assign({}, state, {
                vzwOfferEligibilityCallPage: action.value
            }))

        case CheckLQ.updateSigninBtnStatus:
            return Object.assign({}, state, {
                showSignIn: action.value
            })
        case CheckLQ.showLQonAdrEntry:
            return Object.assign({}, state, {
                showLQBtnAdrEntry: action.value,
                showLQBtn: action.value
            })
        case CheckLQ.isoneLQFlow:
            return (Object.assign({}, state, {
                isoneLQFlow: action.value
            }))
        case CheckLQ.isQAMLessFlow:
            return (Object.assign({}, state, {
                isQAMLessFlow: action.value
            }))    
        case CheckLQ.isBuffalloDMA:
            return (Object.assign({}, state, {
                isBuffalloDMA: action.value
            }))
        case CheckLQ.isamazonmover:
            return (Object.assign({}, state, {
                isamazonMovers: action.value
            }))
        case CheckLQ.isoneLQFlowDev:
            return (Object.assign({}, state, {
                isoneLQFlowDev: action.value
            }))
        case CheckLQ.isMultiadr:
            return (Object.assign({}, state, {
                isMultiadr: action.value
            }))
        case CheckLQ.skipCaptcha:
            return (Object.assign({}, state, {
                skipCaptcha: action.value
            }))
        case CheckLQ.adrEntered:
            return (Object.assign({}, state, {
                adrEntered: action.value
            }))
        /* case CheckLQ.unitEntered:
            return (Object.assign({}, state, {
                unitEntered: action.value
            })) */
        case CheckLQ.suggestedAddress: {
            return (Object.assign({}, state, {
                suggestedAddress: action.value
            }))
        }
        case CheckLQ.captchaChanged: {
            return (Object.assign({}, state, {
                captchaState: action.value,
            }))
        }
        case CheckLQ.TriggerLQ: {
            return (Object.assign({}, state, {
                triggerLQ: action.value,
            }))
        }
        case CheckLQ.isCaptchaAPI: {
            return (Object.assign({}, state, {
                isCaptchaAPI: action.value,
            }))
        }
        case CheckLQ.showCaptchaLBOFromVisitId: {
            return (Object.assign({}, state, {
                showCaptchaFromVisitId: action.showCaptchaFromVisitId,
                showLBOFromVisitId: action.showLBOFromVisitId,
            }))
        }
        case CheckLQ.updateAgencyId: {
            const {
                agencyId
            } = action;
            return (Object.assign({}, state, {
                agencyId
            }))
        }
        case CheckLQ.showStadiaOffer: {
            return (Object.assign({}, state, {
                showStadia: action.showStadia
            }))
        }
        case CheckLQ.showMarvelOffer: {
            return (Object.assign({}, state, {
                showMarvel: action.showMarvel
            }))
        }
        case CheckLQ.updateMFRTType: {
            return (Object.assign({}, state, {
                mfrtType: action.mfrtType
            }))
        }
        case CheckLQ.TWSLQ2: {
            return (Object.assign({}, state, {
                TWSlq2: action.value
            }))
        }
        case CheckLQ.MilvetHeaderhide: {
            return (Object.assign({}, state, {
                mfrtHeaderhide: action.mfrtHeaderhide
            }))
        }
        case 'VZWOFFER_DETAILS': {
            return (Object.assign({}, state, {
                vzwOffer: action.value
            }))
        }
        case 'CHECKPDC_FCCLEARN': {
            return (Object.assign({}, state, {
                checkPDCResFCC: action.value
            }))
        }
        case 'SET_VZW_MTN':
            return Object.assign({}, state, {
                vzwMtn: action.value
            });
        case 'SET_VZW_ACCOUNTELIGIBLE':
            return Object.assign({}, state, {
                isVzwAccountEligibile: action.value
            });
        case 'SET_NPMLOF_FLOW':
            return Object.assign({}, state, {
                npmLofFlow: action.value
            });
        case 'RUNTIME_KEY': {
            return (Object.assign({}, state, {
                runtimeKey: action.value
            }))
        }
        case 'ADDRESSID':
            return Object.assign({}, state, {
                addressIDSelected: action.value
            })
        case 'VENDORNAME':
            return Object.assign({}, state, {
                vendorName: action.value
            })
        case CheckLQ.updateIsVendorVisit:
            return Object.assign({}, state, {
                isVendorVisit: action.isVendorVisit
            })
        case CheckLQ.updateAccessCode:
            return Object.assign({}, state, {
                accessCode: action.isAccessCode
            })
        case CheckLQ.updateStartdatetimestamp:
            return Object.assign({}, state, {
                startdatetimestamp: action.startdatetimestamp
            })
        case "MLPFFCOUPONINFO":
            let ffCouponInfoInput = Object.assign({}, state.mlpFFCouponInfo, {
                ffCoupon: action.value.ffCoupon,
                leadListID: action.value.leadListID,
                isMLPPromoRefreshRequired: action.value.isMLPPromoRefreshRequired
            })
            return Object.assign({}, state, {
                mlpFFCouponInfo: ffCouponInfoInput
            })
        case 'SHOW_NEW_YOUTUBE_CHANGES':
            return Object.assign({}, state, {
                showNewYoutubeChanges: action.value
            });
        case 'FETCH_EMERGENCY_NOTIFICATION_STATES_CONFIG':
            let emergencyNotificationStatesConfig = Object.assign({}, state.emergencyNotification, {
                states: action.value
            })
            return Object.assign({}, state, {
                emergencyNotification: emergencyNotificationStatesConfig
            })
        case CheckLQ.resetLqData:
            return Object.assign({}, state, {
                selectedState: null,
                selectedAdr: null,
                selectedUnit: null,
                showCity: false,
                showExistingService: false,
                showUnit: false,
                showLQBtn: false,
                zipCodes: [],
                streetAddrs: [],
                units: [],
                lqResponse: {},
                checkfor5gresponse: {},
                is5GRecommended: false,
                servicesQualified: {
                    isDataQualified: true,
                    isHsiQualified: true,
                    isVideoQualified: true,
                    isVoiceQualified: true
                },
                lqQualdetails: {},
                showZipLoader: false,
                isRememberMeChecked: true,
                redirectingFYH: 'N',
                lboRedirectOOF: 'N',
                newService: true,
                lqRevisit: "N",
                triggerLQ: false,
                showLQBtnAdrEntry: false,
                adrEntered: '',
                unitEntered: '',
                signInAs: "AF",
                zipNotFound: false,
                suggestedAddress: [],
                futureNotification: {
                    fNameErr: false,
                    lNameErr: false,
                    emailErr: false,
                    mtnErr: false,
                    ftvCheckErr: false,
                    ftvCheck: false,
                    firstName: "",
                    lastName: "",
                    eMailID: "",
                    mtn: "",
                    phoneNo: {
                        ph1: '',
                        ph2: '',
                        ph3: ''
                    },
                    validationsucess: false,
                    validationfailure: false,
                },
                cantFindAddress: false,
                disableUnitTypeahead: false,
                existingSerive: "",
                MFRTNService: "",
                move: {
                    isPendingOrderAvailable: false
                },
                signInCoupon: {
                    mtn: "",
                    phoneNo: {
                        ph1: '',
                        ph2: '',
                        ph3: ''
                    },
                    mtnErr: false,
                    phoneNumCheck: false,
                },
                vendorDetails: null,
                vendorName: '',
                isCCEligible: "N",
                isVZWOfferCallComplete: false,
                iONTEligible: false,
                vzwOfferEligibilityCallPage: "",
                is5GRecommended: false,
                is4GRecommended: false,
                showStreetLoader: false,
                isNYDMA: false,
                isResidentialAddress: false
            });
        case 'FIVEGELIGIBLEZIP':
            return Object.assign({}, state, {
                fiveGEligibleZip: action.value
            })
        case CheckLQ.sweetnerMsgMFRT:
            return Object.assign({}, state, {
                sweetnerMsgMFRT: action.value
            })
        case CheckLQ.dtmTransactionsMFRT:
            return Object.assign({}, state, {
                dtmTransactionsMFRT: action.value
            })
        case CheckLQ.MFRTEligible:
            return Object.assign({}, state, {
                MFRTEligible: action.value
            })
        case CheckLQ.ValidateApiCount:
            return Object.assign({}, state, {
                apiCount: state.apiCount + 1
            })
        case CheckLQ.ResetApiCount:
            return Object.assign({}, state, {
                apiCount: action.value
            })
        case CheckLQ.errorSigninMH: 
        return Object.assign({}, state, {
            signInErrorMH: action.value
        })
        case CheckLQ.skipfornowMH:
            return Object.assign({}, state, {
                skipfornowMH: action.value
            })
        case CheckLQ.signinMHSuccess:
            return Object.assign({}, state, {
                signinMHSuccess: action.value
            })
        case CheckLQ.MFRTVerified:
            return Object.assign({}, state, {
                MFRTVerified: action.value
            })
            case CheckLQ.mfrtInitialLoad:
            return Object.assign({}, state, {
                mfrtInitialLoad: action.value
            })
        case CheckLQ.MFRTCompleted:
            return Object.assign({}, state, {
                MFRTCompleted: action.value
            })
        case CheckLQ.MFRTMovesFlow:
            return Object.assign({}, state, {
                MFRTMovesFlow: action.value
            })
        case CheckLQ.MFRTDiscountEligible:
            return Object.assign({}, state, {
                MFRTDiscountEligible: action.value
            })
        case CheckLQ.MFRTProfileDiscountEligible:
            return Object.assign({}, state, {
                MFRTProfileDiscountEligible: action.value
            })
        case CheckLQ.mnhCheckoutInfo:
            let mnh_Data = Object.assign({}, state.mnh, {
                getCheckoutDataCalled: true,
                checkoutData: action.value
            })
            return Object.assign({}, state, {
                mnh: mnh_Data
            })
        case CheckLQ.MNHAUTOPAYDEFAULTTAGGIMG:
            let mnh_Default_tagging = Object.assign({}, state.mnh, {
                defaultTaggingFired: action.value
            })
            return Object.assign({}, state, {
                mnh: mnh_Default_tagging
            })
        case CheckLQ.MFRTProfileDiscountEligible:
            return Object.assign({}, state, {
                MFRTProfileDiscountEligible: action.value
            })
        case CheckLQ.MNHFlow:
            let isMNHFlow = Object.assign({}, state.mnh, {
                mnhFlow: action.value
            })
            return Object.assign({}, state, {
                mnh: isMNHFlow
            })
        case CheckLQ.MNHPDCData:
            let mnhpdcData = Object.assign({}, state.mnh, {
                pdcData: action.value
            })
            return Object.assign({}, state, {
                mnh: mnhpdcData
            })
        case CheckLQ.MNHGigQualified:
            let isGigqualified = Object.assign({}, state.mnh, {
                isGigqualified: action.value
            })
            return Object.assign({}, state, {
                mnh: isGigqualified
            })
        case CheckLQ.PushNotificationEnable:
                return Object.assign({}, state, {
                    isPushNotificationEnable: action.value
         })
        case CheckLQ.MNHChangeAdrFlow:
            let isChangeAdr = Object.assign({}, state.mnh, {
                isChangeAdr: action.value
            })
            return Object.assign({}, state, {
                mnh: isChangeAdr
            })
        case CheckLQ.MNHQueryString:
            let isMNHQueryStr = Object.assign({}, state.mnh, {
                isMNHQS: action.value
            })
            return Object.assign({}, state, {
                mnh: isMNHQueryStr
            })
        case CheckLQ.MNHONECLICKFLOW:
            let isMNHOneClickFlow = Object.assign({}, state.mnh, {
                isOneClickFlow: action.value
            })
            return Object.assign({}, state, {
                mnh: isMNHOneClickFlow
            })
        case CheckLQ.MNHReserveSIDueDate:
            let ReserveSIDueDate = Object.assign({}, state.mnh, {
                reserveSIDueDate: action.value
            })
            return Object.assign({}, state, {
                mnh: ReserveSIDueDate
            })
        case CheckLQ.MNHSHOWCARTONCHECKOUT:
            let showCart = Object.assign({}, state.mnh, {
                showCartOnCheckout: action.value
            })
            return Object.assign({}, state, {
                mnh: showCart
            })
        case CheckLQ.MNHCREDITCOMPLETED:
            let mnhCreditCompleted = Object.assign({}, state.mnh, {
                isCreditCompleted: action.value
            })
            return Object.assign({}, state, {
                mnh: mnhCreditCompleted
            })
        case 'RESETZIPSTREETNOTFOUND':
            return Object.assign({}, state, {
                zipNotFound: false,
                streetNotFound: false,
                fiveGEligibleZip: false
            })
        case 'QUICK_CHECKOUT':
            return Object.assign({}, state, {
                quickCheckout: action.value
            })
        case 'SET_STREET_FETCH_DONE':
            return Object.assign({}, state, {
                isStreetFetchDone: action.value
            })
        case 'SET_EC_LQ_Response':
            return Object.assign({}, state, {
                ecLQResponse: action.value
            })
        case 'UPDATE_WALMARTFLOW':
            return Object.assign({}, state, {
                walmartflow: action.value && action.value === 'y'
            })
        case 'UPDATE_NEWOFFERTILE':
            return Object.assign({}, state, {
                newoffertile: action.value && action.value === 'y'
            })
        case 'UPDATE_MOVERSINVOKED':
            return Object.assign({}, state, {
                moversInvoked: action.value
            })
        case 'UPDATE_RES_ADDRESS_STATUS':
            return Object.assign({}, state, {
                isResidentialAddress: action.value
        })
        case 'UPDATE_MOVERSINTENT':
            return Object.assign({}, state, {
                moversIntent: action.value
        })
        case "INPUT_ADDRESS":
            return (Object.assign({}, state, {
                inputAddress: action.value
            }))
        case "VCG_OOF_SHOW_VBG_MSG":
            return (Object.assign({}, state, {
                vcgOOFShowVBGMsg: action.value
        }))
        case "DISPLAY_STUDENT_REVERIFY_SUCCESS_VERBAIGE":
            return Object.assign({}, state, {
                displayStudentReverifySuccessMsg: action.value
        });
        default:
            return state
    }
}

export default loopQual